import React, { useState, useEffect, useRef } from 'react';
import '../css/Navbar.css';

import ScrollButton from './ScrollButton';

function Navbar() {

    const [menuOpen, setMenuOpen] = useState(false);
    const [conocenosOpen, setConocenosOpen] = useState(false);
    const [utilesOpen, setUtilesOpen] = useState(false);
    const [galeriaOpen, setGaleriaOpen] = useState(false);

    const navbarRef = useRef(null);

    const toggleMenu = () => setMenuOpen(!menuOpen);

    const toggleConocenos = () => setConocenosOpen(!conocenosOpen);

    const toggleGaleria = () => setGaleriaOpen(!galeriaOpen);

    const toggleUtiles = () => setUtilesOpen(!utilesOpen);

    const closeMenu = () => {

        setMenuOpen(false);
        setConocenosOpen(false);
        setUtilesOpen(false);
        setGaleriaOpen(false);

    };

    useEffect(() => {

        const handleClickOutside = (event) => {

            if (
                navbarRef.current &&
                !navbarRef.current.contains(event.target)
            ) {

                closeMenu();

            }

        };

        document.addEventListener(
            'click',
            handleClickOutside
        );

        return () => {

            document.removeEventListener(
                'click',
                handleClickOutside
            );

        };

    }, []);

    return (

        <nav
            className={`esc-navbar ${menuOpen ? 'esc-open' : ''}`}
            ref={navbarRef}
        >

            <div className="esc-navbar-logo">
                {/* Logo opcional */}
            </div>

            <div
                className="esc-navbar-toggle"
                onClick={toggleMenu}
            >

                <div className="esc-navbar-bar"></div>
                <div className="esc-navbar-bar"></div>
                <div className="esc-navbar-bar"></div>

            </div>

            <ul
                className={`esc-navbar-menu ${menuOpen ? 'esc-open' : ''}`}
            >

                <li>

                    <a
                        href="#inicio"
                        onClick={closeMenu}
                    >
                        Inicio
                    </a>

                </li>

                <li>

                    <a
                        href="#events-component"
                        onClick={closeMenu}
                    >
                        Informaciones
                    </a>

                </li>

                <li
                    className={`esc-navbar-dropdown ${conocenosOpen ? 'esc-open' : ''}`}
                >

                    <a
                        href="#"
                        onClick={toggleConocenos}
                    >
                        Conócenos
                    </a>

                    <ul
                        className={`esc-navbar-submenu ${conocenosOpen ? 'esc-open' : ''}`}
                    >

                        <li><a href="#QuienesSomos" onClick={closeMenu}>Quiénes Somos</a></li>

                        <li><a href="#personal-establecimiento" onClick={closeMenu}>Personal del Establecimiento</a></li>

                        <li><a href="#nuestra-mision-component" onClick={closeMenu}>Nuestra Misión</a></li>

                        <li><a href="#vision-component" onClick={closeMenu}>Visión</a></li>

                        <li><a href="#sellos-component" onClick={closeMenu}>Sellos</a></li>

                        <li><a href="#valores-component" onClick={closeMenu}>Valores</a></li>

                    </ul>

                </li>


                <li
                    className={`esc-navbar-dropdown ${galeriaOpen ? 'esc-open' : ''}`}
                >

                    <a
                        href="#"
                        onClick={toggleGaleria}
                    >
                        Galerías & Trabajos
                    </a>

                    <ul
                        className={`esc-navbar-submenu ${galeriaOpen ? 'esc-open' : ''}`}
                    >

                        <li><a href="#cuadrohonor-component" onClick={closeMenu}>Cuadro de Honor</a></li>

                        <li><a href="#licenciados-component" onClick={closeMenu}>Licenciados & Graduados</a></li>

                        <li><a href="#videos-container" onClick={closeMenu}>Galería Audiovisual</a></li>

                        <li><a href="#Instagram-list" onClick={closeMenu}>Galería Instagram</a></li>

                        <li>

                            <a
                                href="https://padlet.com/g4pzjdvh65/talleres-jec-de-artes-dggvfttlwwonztsd"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={closeMenu}
                            >

                                Galería de Arte

                            </a>

                        </li>

                        <li><a href="#biblioteca-cra-component" onClick={closeMenu}>Biblioteca CRA</a></li>

                    </ul>

                </li>

                <li>

                    <a
                        href="#centro-innovacion-component"
                        onClick={closeMenu}
                    >
                        Centro de Innovación
                    </a>

                </li>

                <li>

                    <a
                        href="#documentos"
                        onClick={closeMenu}
                    >
                        Documentos Institucionales
                    </a>

                </li>

                <li>

                    <a
                        href="#Listajunaeb"
                        onClick={closeMenu}
                    >
                        Alimentación Junaeb
                    </a>

                </li>

                <li>

                    <a
                        href="#listacursos"
                        onClick={closeMenu}
                    >
                        Útiles Escolares 2026
                    </a>

                </li>

                <li>

                    <a
                        href="#contacto"
                        onClick={closeMenu}
                    >
                        Contacto
                    </a>

                </li>

                <ScrollButton direction="top" />
                <ScrollButton direction="bottom" />

            </ul>

        </nav>

    );

}

export default Navbar;